import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import { DeleteOutlined, SafetyCertificateOutlined } from "@ant-design/icons"; //  EditOutlined,

import DataTable from "../../../components/DataTable";

const rolesMap = [
  { label: "Admin", value: "ADMIN", color: "#e29b45" },
  { label: "Super User", value: "SUPERUSER", color: "#0d2e4d" },
  { label: "User", value: "USER", color: "#2ecc71" },
];

export default function SkeyeformUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  //onEditUser,
  onEditRole,
  onDeleteUser,
  isRoleUser,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "10%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: "20%",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "25%",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Roles",
      key: "roles",
      width: "20%",
      render: (_, record) => {
        if (!record.roles || !Array.isArray(record.roles)) return "N/A";
        return (
          <Space size={[0, 4]} wrap>
            {record.roles.map((roleObj, idx) => {
              const match = rolesMap.find(
                (r) => `ROLE_${r.value}` === roleObj.name,
              );
              return (
                <Tag color={match ? match.color : "default"} key={idx}>
                  {match ? match.label : roleObj.name}
                </Tag>
              );
            })}
          </Space>
        );
      },
    },
    {
      title: "Skeyechart Access",
      dataIndex: "exportToSkeyechart",
      key: "exportToSkeyechart",
      width: "10%",
      render: (active) => (
        <Tag color={active ? "success" : "error"}>
          {active ? "Enabled" : "Disabled"}
        </Tag>
      ),
      sorter: (a, b) =>
        a.exportToSkeyechart === b.exportToSkeyechart
          ? 0
          : a.exportToSkeyechart
            ? -1
            : 1,
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => {
        const currentRoleName = record.roles?.[0]?.name || "";
        const match = rolesMap.find(
          (r) => `ROLE_${r.value}` === currentRoleName,
        );
        const currentRoleLabel = match ? match.label : null;

        return (
          <Space size="small">
            {/*             <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => onEditUser(record)}
              style={{ color: "#e29b45" }}
              title="Edit User Info"
            /> */}
            <Button
              type="text"
              icon={<SafetyCertificateOutlined />}
              onClick={() => onEditRole(record, currentRoleLabel)}
              style={{ color: "#D97A07" }}
              title="Edit Role"
            />
            <Popconfirm
              title="Delete User"
              description={`Are you sure you want to delete "${record.username}"?`}
              onConfirm={() => onDeleteUser(record.id)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                title="Delete User"
              />
            </Popconfirm>
          </Space>
        );
      },
    });
  }

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
